import PicklistMetadata from "../PicklistMetadata";

class ProjectPlanPhaseMilestoneReferenceDocumentRevisionPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneReferenceDocumentRevision";
        this.bounded = true;
        this.enterpriseComponent = "DocumentRevisionRD";
        this.longList = true;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = false;
        this.typeField = "Document";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseMilestoneReferenceDocumentRevisionPicklistMetadata;
